module.exports = __webpack_public_path__ + "img/arrow-rb.3ae6a629.svg";